import type { JSX, ReactNode } from 'react';

import { cssClasses } from 'pkg/css/utils';

import MaterialSymbol from 'components/material-symbols';

import { Spinner } from 'components/loaders/spinner';
import type { MaterialSymbolVariant } from 'components/material-symbols/symbols';

import * as css from './styles.css';

interface ConnectionProps {
	leftComponent: ReactNode;
	rightComponent: ReactNode;
	iconName?: MaterialSymbolVariant;
	pending?: boolean;
	className?: string;
}

export default function Connection({
	leftComponent = null,
	rightComponent = null,
	iconName,
	pending,
	className,
}: ConnectionProps): JSX.Element {
	return (
		<div className={cssClasses(css.wrapper, className)}>
			<div className={css.item}>{leftComponent}</div>
			<div className={css.iconWrapper}>
				{!pending ? (
					<MaterialSymbol variant={iconName || 'link'} className={css.icon} />
				) : (
					<Spinner size="30px" />
				)}
			</div>
			<div className={css.item}>{rightComponent}</div>
		</div>
	);
}
